import React from 'react'
import { getChangedFieldsets, hasChangedValues, getFormValue } from 'tyan/public/utility'

class ChildInstrumentDiv extends React.Component {
    state = {
        instrumentID: this.props.instrumentID || 0,
        search: '',
    }

    componentDidMount = () => {
        this.doGetChildInstrumentSettings(this.state.search)
    }

    doGetChildInstrumentSettings = (search) => {
        const { instrumentID } = this.state
        Tyan.doPostEvent('GetChildInstrumentSettings', {
            data: { instrumentID, search },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息 })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { instrumentID } = this.state
        Tyan.doPostEvent('SaveChildInstrumentSettings', {
            data: { instrumentID, ...getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }


    canSave = () => {
        return this.bChanged()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { optionsParas: { item设备列表 } } = this.state
        return [
            {
                _checkgrid: '', name: '设备列表', rowNumbers: false, minRows: 5, maxRows: 15,
                itemsValues: item设备列表, onSearch: (v) => this.doGetChildInstrumentSettings(v),
                columns: [
                    { _text: '设备编号', minWidth: 200 },
                    { _text: '设备名称', minWidth: 400 },
                ],
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} minWidth={600}
            controls={
                [
                    { _button: '确定', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: '取消', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default ChildInstrumentDiv